import { Component, OnInit, ElementRef } from '@angular/core';
import { SearchOverlayService } from 'src/app/sidenav/search-overlay/search-overlay.service';

@Component({
  selector: 'app-search-overlay',
  templateUrl: './search-overlay.component.html',
  styleUrls: ['./search-overlay.component.scss']
})
export class SearchOverlayComponent implements OnInit {

  headerComponents;
  show: boolean;

  constructor(private seekerService: SearchOverlayService) {
                this.headerComponents = [];
                this.show = false;
              }

  ngOnInit() {
    this.seekerService.listenSeekerStatus().subscribe(
      (res) => {
        this.show = !this.show;
      }
    );
  }

  private toggle() {
    this.show = !this.show;
  }

}
